import { createSlice } from "@reduxjs/toolkit";
import { getCountriesReducer } from "./reducers";
import { COUNTRIES_SLICE_NAME } from "./actions";
import { ISelectOption } from "src/@types/form";

export interface ICountriesState {
  countries: {
    isLoading: boolean;
    items: ISelectOption[];
  };
}

const initialState: ICountriesState = {
  countries: {
    isLoading: false,
    items: [],
  },
};

export const { reducer: countries } = createSlice({
  name: COUNTRIES_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers(builder) {
    getCountriesReducer(builder);
  },
});
